"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Name = exports.Zip = exports.State = exports.City = exports.Street = void 0;
const react_1 = __importDefault(require("react"));
const joinLocationFields = (location) => location.filter((v) => !!v).join(', ');
const Street = ({ street1, street2, suite }) => (react_1.default.createElement("span", { itemProp: "streetAddress" }, joinLocationFields([street1, street2, suite])));
exports.Street = Street;
const City = (props) => react_1.default.createElement("span", Object.assign({}, props, { itemProp: "addressLocality" }));
exports.City = City;
const State = (props) => react_1.default.createElement("span", Object.assign({}, props, { itemProp: "addressRegion" }));
exports.State = State;
const Zip = ({ children }) => (react_1.default.createElement("span", { itemProp: "postalCode" }, children));
exports.Zip = Zip;
const Name = ({ children }) => react_1.default.createElement("h5", null, children);
exports.Name = Name;
//# sourceMappingURL=Location.utils.js.map